"use client";

import { Archive, BookMarked, ClipboardList, Sliders } from "lucide-react";

import { ResearchFeedArchives } from "@/components/archives";
import { CustomizeSummaries } from "@/components/customize";
import ListLeft from "@/components/list-left";
import { MobileMenuView } from "@/components/menu-view";
import { Button } from "@/components/ui/button";
import { useAccess } from "@/lib/hooks/use-access";
import { AccessRules } from "@/types";

import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface ResearchFeedLContentProps {
	accessRules: AccessRules;
	settings: any;
}

const ResearchFeedLContent = ({ accessRules, settings }) => {
	const hasAccess = useAccess("study_summaries");
	// const { user, study_summaries: hasAccess } = accessRules;
	const { user } = accessRules;

	const links = [
		{
			title: `Dashboard`,
			href: `/research-feed`,
			icon: <ClipboardList strokeWidth={1} size={22} />,
		},
		{
			title: `Research Feed Archive`,
			component: (
				<ResearchFeedArchives user={user}>
					<Button
						variant="text"
						className="hover:text-stroke flex w-full cursor-pointer items-center gap-3 rounded px-1.5 py-2 text-gray-900 hover:bg-gray-200/50 hover:text-examine-purple-500 active:bg-gray-200 2xl:gap-3"
					>
						<Tooltip>
							<TooltipTrigger asChild>
								<span className="grid size-5 shrink-0 place-content-start 3xl:size-6">
									<Archive strokeWidth={1} size={22} />
								</span>
							</TooltipTrigger>
							<TooltipContent variant="purple" className="[@media(max-width:768px)]:hidden">
								Research Feed Archive
							</TooltipContent>
						</Tooltip>
						<span className="whitespace-normal text-sm capitalize -tracking-2 peer-checked/left:group-[]:inline-flex lg:hidden xl:text-base 3xl:text-lg 3xl:leading-9">
							Research Feed Archive
						</span>
					</Button>
				</ResearchFeedArchives>
			),
		},
		{
			title: `Continuing Education`,
			href: `/members/continuing-education/`,
			blockAccess: !hasAccess,
			icon: <BookMarked strokeWidth={1} size={22} />,
		},
		{
			title: `Customize`,
			blockAccess: !hasAccess,
			component: (
				<CustomizeSummaries user={user} settings={settings}>
					<Button
						variant="text"
						className="hover:text-stroke flex w-full cursor-pointer items-center gap-3 rounded px-1.5 py-2 text-gray-900 hover:bg-gray-200/50 hover:text-examine-purple-500 active:bg-gray-200 2xl:gap-3"
					>
						<Tooltip>
							<TooltipTrigger asChild>
								<span className="grid size-5 shrink-0 place-content-start 3xl:size-6">
									<Sliders strokeWidth={1} size={22} />
								</span>
							</TooltipTrigger>
							<TooltipContent variant="purple" className="[@media(max-width:768px)]:hidden">
								Customize
							</TooltipContent>
						</Tooltip>
						<span className="whitespace-normal text-sm capitalize -tracking-2 peer-checked/left:group-[]:inline-flex lg:hidden xl:text-base 3xl:text-lg 3xl:leading-9">
							Customize
						</span>
					</Button>
				</CustomizeSummaries>
			),
		},
	];

	return (
		<MobileMenuView title={"Research Feed"}>
			<ListLeft links={links} />
		</MobileMenuView>
	);
};

export default ResearchFeedLContent;
